import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import { portalHomePath } from "./portal_paths";
import { usePortalPartnerSlug } from "./use_portal_partner_slug";

function useAuthCallback(partnerSlug: string | undefined) {
  const { isAuthenticated, isLoading } = useAuth0();
  const history = useHistory();

  useEffect(() => {
    // Only the signed-in exit belongs here: a visitor with no session is shown the
    // login screen by the gate above, which never mounts this page. Without a
    // partner there is no address to go to, and interpolating an absent one would
    // navigate to a portal that cannot load.
    if (isLoading || !isAuthenticated || !partnerSlug) {
      return;
    }

    history.replace(portalHomePath(partnerSlug));
  }, [isLoading, isAuthenticated, partnerSlug, history]);
}

export function PortalCallbackPage() {
  const partnerSlug = usePortalPartnerSlug();
  useAuthCallback(partnerSlug);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Spinner animation="border" />
    </div>
  );
}
